import React, { useEffect, useState } from "react";
import qs from "qs";
import { payments } from "../../services";
import {
  PAYMENT_STATUS_SUCCESS,
  PHONE_CONTACT,
  RESULT_PAYMENT_PAYOO,
  ROUTER_PATH,
} from "../../common/constant";
import { Result } from "antd";
// import { useTranslation } from "react-i18next";
import { localizeRouteKey } from "../../shared/helpers";

const PaymentReturn = (props: any) => {
  // const { t } = useTranslation();
  const { history } = props;
  const [statusRespose, setStatusResponse] = useState(false);
  const [orderInfo, setOrderInfo] = useState<any>({});

  useEffect(() => {
    const order_no: any = qs
      .parse(props.location.search, { ignoreQueryPrefix: true })
      ?.order_no?.toString();
    const status: any = qs
      .parse(props.location.search, { ignoreQueryPrefix: true })
      .status?.toString();

    if (
      status === RESULT_PAYMENT_PAYOO.SUCCESS ||
      status === PAYMENT_STATUS_SUCCESS
    ) {
      setStatusResponse(true);
    }

    payments.payooVerifyTransaction({ order_no }, (data: any, err: any) => {
      if (data && data.status === PAYMENT_STATUS_SUCCESS) {
        setOrderInfo(data);
      } else {
        setStatusResponse(false);
      }
    });
  }, []);

  return (
    <div style={{ minHeight: "calc(100vh - 55px - 300px)" }}>
      <Result
        status={statusRespose ? "success" : "warning"}
        title={
          statusRespose ? (
            <span>
              Đơn hàng{" "}
              <a
                onClick={() =>
                  history.push(
                    localizeRouteKey(ROUTER_PATH.ORDERS) +
                      `/${orderInfo.order_id}`
                  )
                }>
                {orderInfo.kde_order_id || ""}
              </a>{" "}
              của quý khách đã được đặt thành công!
              <br />
              Xem chi tiết đơn hàng{" "}
              <a
                onClick={() =>
                  history.push(
                    localizeRouteKey(ROUTER_PATH.ORDERS) +
                      `/${orderInfo.order_id}`
                  )
                }>
                tại đây
              </a>
              .
            </span>
          ) : (
            <span>
              Quá trình thanh toán đã xảy ra lỗi! Vui lòng liên hệ{" "}
              <a href={`tel:${PHONE_CONTACT}`}>{PHONE_CONTACT}</a> để được hướng
              dẫn thêm.
            </span>
          )
        }
        subTitle={
          <span>
            Chúng tôi sẽ liên lạc với quý khách sớm nhất. Mọi chi tiết xin vui
            lòng liên hệ <a href={`tel:${PHONE_CONTACT}`}>{PHONE_CONTACT}</a>
          </span>
        }
      />
    </div>
  );
};

export default PaymentReturn;
